import { render, staticRenderFns } from "./Cables.vue?vue&type=template&id=4675f11f"
import script from "./Cables.vue?vue&type=script&lang=js"
export * from "./Cables.vue?vue&type=script&lang=js"
import style0 from "./Cables.vue?vue&type=style&index=0&id=4675f11f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports